// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"searchInput_searchInput__2G95_"};